/* 🤖 this file was generated by script */
export const wiconStatuspage = {
  name: 'statuspage',
  data: `<svg viewBox="0 0 20 20"><path fill="currentColor" d="M10 15.31a3.28 3.28 0 100-6.55 3.28 3.28 0 000 6.55z"/><path fill="currentColor" d="M3.09 8.24l1.76 2.09a.37.37 0 00.53.04c2.85-2.56 6.38-2.56 9.24 0a.38.38 0 00.53-.04l1.76-2.09a.38.38 0 00-.04-.53c-4.14-3.61-9.6-3.61-13.74 0a.38.38 0 00-.04.53z"/></svg>`,
};
